<template>
  <v-app>
    <v-navigation-drawer
      v-model="drawer"
      :clipped="$vuetify.breakpoint.lgAndUp"
      app
    >
      <v-list dense class="pt-0">
        <v-list-item
          v-for="item in items"
          :key="item.text"
          :to="{ path: item.path }"
        >
          <v-list-item-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <!--<v-toolbar
      color="blue darken-3"
      dark
      app
      :clipped-left="$vuetify.breakpoint.mdAndUp"
      fixed
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
        <v-toolbar-side-icon
          @click.stop="drawer = !drawer"
        ></v-toolbar-side-icon>
        <span class="hidden-sm-and-down">Strata Resilience </span>
      </v-toolbar-title>
      &lt;!&ndash;<v-text-field
                    flat
                    solo-inverted
                    prepend-icon="search"
                    label="Search"
                    class="hidden-sm-and-down">
            </v-text-field>&ndash;&gt;
      <v-spacer></v-spacer>
      &lt;!&ndash; <v-btn icon>
                <v-icon>apps</v-icon>
            </v-btn>&ndash;&gt;
      <v-btn
        color="blue darken-3"
        class="white&#45;&#45;text"
        depressed
        @click="logout()"
      >
        Logout
      </v-btn>
      <div class="text-xs-center">
        <v-menu offset-y>
          <v-btn icon slot="activator">
            <v-icon>mdi-notifications</v-icon>
          </v-btn>

          <v-list>
            <v-list-tile v-for="(item, index) in notifications" :key="index">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </div>

      <v-btn icon large @click="gotoHome()">
        <v-avatar size="32px" tile>
          <img src="../assets/logo.svg" alt="STP" />
        </v-avatar>
      </v-btn>
    </v-toolbar>-->
    <v-app-bar
      :clipped-left="$vuetify.breakpoint.lgAndUp"
      app
      color="blue darken-3"
      dark
    >
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
        <span class="hidden-sm-and-down">NQSTIP</span>
      </v-toolbar-title>
      <div class="flex-grow-1"></div>
      <v-btn
        color="blue darken-3"
        class="white--text"
        depressed
        @click="logout()"
        >Logout</v-btn
      >
      <v-btn icon large>
        <v-avatar size="32px" tile>
          <v-img src="../assets/logo.svg" alt="STIP"> </v-img
        ></v-avatar>
      </v-btn>
    </v-app-bar>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { router } from "../router";
import jwt_decode from "jwt-decode";
import { checkLogin } from '../helpers/check'

export default {
  name: "Nav",
  data() {
    return {
      dialog: false,
      drawer: true,
      clipped: true,
      items: [
        { icon: "mdi-home", text: "Dashboard", path: "/dash" },
        { icon: "mdi-map-marker-plus", text: "My Sites", path: "/sites" },
        { icon: "mdi-account-circle", text: "My Account", path: "/member" },
        { icon: "mdi-chat", text: "Send Feedback", path: "/feedback" },
        { icon: "mdi-help", text: "Help", path: "/help" }
      ],
      notifications: [{ title: "No Notifications" }]
    };
  },
  mounted() {
    this.checkLoggedIn();
  },
  methods: {
    gotoHome() {
      router.push("/");
    },
    checkLoggedIn() {
      if (checkLogin()) {
        router.push("/login");
      }

    },
    logout() {
      //this.$session.destroy();
      router.push("/");
    },
    inspectToken() {
      const token = this.$session.has("token");
      if (token) {
        const decoded = jwt_decode(sessionStorage.getItem("token"));
        const exp = decoded.exp;
        const orig_iat = decoded.orig_iat;

        if (exp - Date.now() / 1000 < 1800) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }
  }
};
</script>
